import {gmAPI} from '@/services/MapService';

/**
 * Converts Esri geometry rings to Google Maps LatLng coordinates.
 * Handles coordinate system conversion from Web Mercator (102100/3857) to WGS84.
 */
const convertEsriRingsToLatLng = (
  rings: number[][][],
  spatialReference: {wkid: number} | {latestWkid: number},
): google.maps.LatLng[][] => {
  const wkid = 'wkid' in spatialReference ? spatialReference.wkid : spatialReference.latestWkid;

  return rings.map((ring) =>
    ring.map(([x, y]) => {
      // If Web Mercator (102100 or 3857), convert to WGS84
      if (wkid === 102100 || wkid === 3857) {
        const lng = (x / 20037508.34) * 180;
        let lat = (y / 20037508.34) * 180;
        lat = 180 / Math.PI * (2 * Math.atan(Math.exp(lat * Math.PI / 180)) - Math.PI / 2);
        return new gmAPI.LatLng(lat, lng);
      }

      // If already WGS84 (4326), use directly
      if (wkid === 4326) {
        return new gmAPI.LatLng(y, x); // Note: Esri uses [lng, lat]
      }

      // For other coordinate systems, you may need a library like proj4
      console.warn(`Unsupported spatial reference: ${wkid}`);
      return new gmAPI.LatLng(y, x);
    }),
  );
};

/**
 * Converts a handful of feature attributes into one string of address parts.
 */
const buildAddress = (
  fa: Record<string, string | number>,
  address: string,
  city: string,
  state: string,
  zip: string,
): string | null => {
  const addressParts = [
    fa[address] || '',
    fa[city] || '',
    fa[state] || '',
    fa[zip] || '',
  ];
  const result = addressParts.filter((part) => part).join(', ');
  if (result === '') return null;
  return result;
};


export {
  convertEsriRingsToLatLng,
  buildAddress,
};
